import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useKnowledgebase } from '../../Contexts/KnowledgebaseContext';

export default function ContextualTooltip({ content, articleId, placement = 'top' }) {
  const { openArticle } = useKnowledgebase();
  const [open, setOpen] = useState(false);

  const tooltipContent = (
    <Box sx={{ maxWidth: 280 }}>
      <Typography variant="caption" display="block">{content}</Typography>
      {articleId && (
        <Typography
          variant="caption"
          color="primary.light"
          sx={{ cursor: 'pointer', textDecoration: 'underline', display: 'block', mt: 0.5 }}
          onClick={(e) => { e.stopPropagation(); setOpen(false); openArticle(articleId); }}
        >
          Learn more →
        </Typography>
      )}
    </Box>
  );

  return (
    <Tooltip
      title={tooltipContent}
      placement={placement}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      enterDelay={200}
      arrow
    >
      <IconButton
        size="small"
        aria-label="Help"
        sx={{ p: 0.25, ml: 0.5, color: 'text.secondary' }}
        onKeyDown={(e) => { if (e.key === 'Escape') setOpen(false); }}
      >
        <HelpOutlineIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
}
